<template>
    <div id="contenedor-principal-bitacora" class="container-fluid">
        <!-- SECCION DE ENCABEZADOS -->
        <div id="encabezados">
            <h1>CONSULTA HISTORICO DE CEDULAS</h1>
            <h4>Consulta las cedulas registradas en el sistemas anterior de notificacion judicial</h4>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION DE CONSULTA -->
        <div id="seccion-consulta" class="row">
            <!-- SECCION INFORMATIVA -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-4 mt-3">
                <div class="titulo-contenedores-seccion container-fluid">
                    <h5 class="font-weight-bold"><i class="fas fa-list"></i>&nbsp;&nbsp;Listado de cedulas encontradas</h5>
                </div>
                <!-- SECCION FILTROS DE BUSQUEDA -->
                <div class="contenedor-color-negro row no-gutters pb-2">
                    <h6 class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-2 pb-2 texto-filtros form-inline">
                        <!-- ACCIONES -->
                        <div id="seccion-acciones" class="d-flex justify-content-start mr-4">
                            <button type="button" @click="iniciarProcesoBusquedaDeCedulas" class="btn btn-primary mr-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            <button type="button" @click="limpiarFiltros" class="btn btn-primary"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar filtros</button>
                        </div>
                        <div style="border-left:2px solid #fff;height:2em;" class="mr-3"></div>
                        <i @click="tablaCedulas.filtros.grupos.rangoDeFechas.activo = !tablaCedulas.filtros.grupos.rangoDeFechas.activo" 
                           :class="(!tablaCedulas.filtros.grupos.rangoDeFechas.activo) ? 'far fa-square texto-filtros' : 'fas fa-check-square texto-filtros'"
                           style="cursor: pointer;"></i>&nbsp;&nbsp;Agregar rango de fechas
                    </h6>
                    <!-- FILTRO DE JUZGADO -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Juzgado</h6>
                        <C001Area 
                            :class="[tablaCedulas.filtros.filtroAreaInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" 
                            v-on:valorParaElPadre="evtCambioDeJuzgado" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'TipoAreaVCBCED'" 
                            :parametros="{}" 
                            :valorDefinido="tablaCedulas.filtros.juzgadoId" 
                            :key="'KTipoAreaVCBCED' + tablaCedulas.filtros.contFJuzgado"></C001Area>
                    </div>
                    <!-- FILTRO NUMERO DE EXPEDIENTE -->
                    <div id="filtros" class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Consecutivo</h6>
                        <div class="input-group">
                            <div class="input-group-append">
                                <div class="input-group-text"><i class="fa fa-folder"></i></div>
                            </div>
                            <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="tablaCedulas.filtros.numeroExpediente" v-mask="'####/####'" placeholder="####/####">
                        </div>
                    </div>
                    <!-- FILTRO PARA EL TIPO DE DOCUMENTO -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Tipo de documento</h6>
                        <CCatalogoGenerico class="p-0 m-0" 
                            v-on:valorParaElPadre="evtCambioTipoDeDocumento" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'CTipoDeDocumento_SIS_VIEJO'" 
                            :valorDefinido="tablaCedulas.filtros.tipoDeDocumento.tipoDeDocumentoId"
                            :textoOpcionesSingular="'Documento'"
                            :textoOpcionesPlural="'Documentos'"
                            :elementosCatalogo="tablaCedulas.filtros.tipoDeDocumento.lista"
                            :key="'KCTipoDeDocumento_SIS_VIEJO' + tablaCedulas.filtros.tipoDeDocumento.contadorRender"></CCatalogoGenerico>
                    </div>
                    <!-- FILTRO PARA EL TIPO DE ESTATUS -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Estatus</h6>
                        <CCatalogoGenerico class="p-0 m-0" 
                            v-on:valorParaElPadre="evtCambioTipoEstatus" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'CTipoEstatus_SIS_VIEJO'" 
                            :valorDefinido="tablaCedulas.filtros.estatus.tipoDeEstatusId"
                            :textoOpcionesSingular="'Estatus'"
                            :textoOpcionesPlural="'Estatus'"
                            :elementosCatalogo="tablaCedulas.filtros.estatus.lista"
                            :key="'KTipoEstatus_SIS_VIEJO' + tablaCedulas.filtros.estatus.contadorRender"></CCatalogoGenerico>
                    </div>
                    <!-- FILTRO PARA EL TIPO DE NOTIFICACION -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Tipo de notificacion</h6>
                        <CCatalogoGenerico class="p-0 m-0" 
                            v-on:valorParaElPadre="evtCambioTipoNotificacion" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'CTipoNotificacion_SIS_VIEJO'" 
                            :valorDefinido="tablaCedulas.filtros.tipoNotificacion.tipoNotificacionId"
                            :textoOpcionesSingular="'Tipo de notificacion'"
                            :textoOpcionesPlural="'Tipos de notificacion'"
                            :elementosCatalogo="tablaCedulas.filtros.tipoNotificacion.lista"
                            :key="'KTipoNotificacion_SIS_VIEJO' + tablaCedulas.filtros.tipoNotificacion.contadorRender"></CCatalogoGenerico>
                    </div>
                    <!-- FILTROS RANGO DE FECHAS -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6 for="fechaInicial">Fecha inicial&nbsp;<i v-if="!tablaCedulas.filtros.grupos.rangoDeFechas.activo" class="fas fa-ban text-danger"></i></h6>
                        <input type="date" id="fechaInicial" v-model="tablaCedulas.filtros.fechaInicial" :class="[(tablaCedulas.filtros.grupos.rangoDeFechas.activo) ? 'form-control' : 'form-control catalogoInformativo']" />
                    </div>
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6 for="fechaFinal">Fecha final&nbsp;<i v-if="!tablaCedulas.filtros.grupos.rangoDeFechas.activo" class="fas fa-ban text-danger"></i></h6>
                        <input type="date" id="fechaFinal" v-model="tablaCedulas.filtros.fechaFinal" :class="[(tablaCedulas.filtros.grupos.rangoDeFechas.activo) ? 'form-control' : 'form-control catalogoInformativo']" />
                    </div>
                </div>
                <div class="container-fluid contenedor-color-negro contenedor-tabla-historico-CEDULAS-SINOJ">
                    <table
                        class="table table-striped table-light table-hover"
                        :id="tablaCedulas.ID"              
                        data-toggle="table"
                        data-pagination="true"
                        data-undefined-text="Sin información"
                        data-maintain-selected="true"  
                        data-page-size = "1"
                        data-page-list="[5,10,20]"
                        data-click-to-select="false"
                        data-show-toggle="false"
                        data-show-pagination-switch="true"
                        data-search="true">
                        <thead class="thead-dark">
                            <tr>
                                <th data-halign="center" data-width="5" data-align="center" data-field="Consecutivo" data-sortable="true">
                                    Consecutivo
                                </th>
                                <th data-halign="center" data-width="10" data-align="center" data-field="nombreTipoDocumento" data-sortable="true">
                                    Tipo de documento
                                </th>
                                <th data-halign="center" data-width="10" data-align="center" data-field="TipoCedula" data-sortable="true">
                                    Tipo de cedula
                                </th>
                                <th data-events="operateEvents" data-halign="center" data-width="20" data-align="center" data-field="Domicilio" data-sortable="true">
                                    Domicilio
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="PersonaANotificar" data-sortable="true">
                                    Persona a notificar
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="Estatus" data-sortable="true">
                                    Estatus de la cédula
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="FechaDeCreacion" data-sortable="true">
                                    Fecha creación de la cédula
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="FechaRecibeJuzgado" data-sortable="true">
                                    Fecha resultado de la cédula
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="FechaDeResultado" data-sortable="true">
                                    Fecha recibe juzgado la cédula
                                </th>
                                <th data-events="operateEvents" data-width="10" data-field="AccionVerDocumento" data-halign="center" data-align="center">
                                    Documento de la cédula
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
        <!-- MODAL PARA EL VISOR DE DOCUMENTOS -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documentos">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento de cedula</h5>
                        <button id="btn-cerrar-visor-documentos" @click="visor.cedulaSeleccionada = null" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="this.campoRequeridoEsValido(visor.cedulaSeleccionada)">
                            <div>
                                <PDFDocument 
                                    :url="visor.cedulaSeleccionada.rutaDocumento" 
                                    :height="visor.HEIGHT"
                                    :key="'kVisorDocCedHistorico-' + visor.contRender" />
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import VueMask from 'v-mask'

Vue.use(VueMask);
export default {
    components: {
        C001Area: catalogos.PJ.C001Area,
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        PDFDocument
    },
    data() {
        return {
            enumeraciones,
            tablaCedulas: {
                ID: 'Tabla-bitacora-cedula',
                filtros: {
                    filtroAreaInformativo: false,
                    juzgadoId: -1,
                    numeroExpediente: null,
                    fechaInicial: moment().subtract(5, 'days').format('YYYY-MM-DD'),
                    fechaFinal:  moment().format('YYYY-MM-DD'),
                    contFJuzgado: 1,
                    estatus: {
                        tipoDeEstatusId: -1,
                        lista: [],
                        contadorRender: 1
                    },
                    tipoNotificacion: {
                        tipoNotificacionId: -1,
                        lista: [],
                        contadorRender: 1
                    },
                    tipoDeDocumento: {
                        tipoDeDocumentoId: -1,
                        lista: [],
                        contadorRender: 1
                    },
                    grupos: { 
                        rangoDeFechas: { activo: true } 
                    }
                },
                cedulas: []
            },
            visor: {
                cedulaSeleccionada: null,
                HEIGHT: '600px',
                contRender: 1
            },
            cargoAreaDeUsuario: false
        }
    },
    methods: {
        limpiarFiltros: function() {
            this.tablaCedulas.filtros.numeroExpediente = null;
            this.tablaCedulas.filtros.fechaInicial = moment().subtract(5, 'days').format('YYYY-MM-DD');
            this.tablaCedulas.filtros.fechaFinal =  moment().format('YYYY-MM-DD');
            this.tablaCedulas.filtros.grupos.rangoDeFechas.activo = true;
            this.tablaCedulas.filtros.estatus.tipoDeEstatusId = -1;
            this.tablaCedulas.filtros.estatus.contadorRender ++;
            this.tablaCedulas.filtros.tipoNotificacion.tipoNotificacionId = -1;
            this.tablaCedulas.filtros.tipoNotificacion.contadorRender ++;
            this.tablaCedulas.filtros.tipoDeDocumento.tipoDeDocumentoId = -1;
            this.tablaCedulas.filtros.tipoDeDocumento.contadorRender ++;
        },
        /**
         * Metodo encargado de iniciar el proceso de busqueda y inicializacion de la tabla con el contenido
         * @see {@link construirPeticionBusquedaDeCedulas}
         * @see {@link obtenerCedulasBD}
         * @see {@link inicializarTabla}
         */
        iniciarProcesoBusquedaDeCedulas: async function() {
            const PETICION_API = await Promise.resolve(this.construirPeticionBusquedaDeCedulas());
            const SE_OBTUVIERON_CEDULAS = await Promise.resolve(this.obtenerCedulasBD({ peticion: PETICION_API }));
            if(SE_OBTUVIERON_CEDULAS)
                await Promise.resolve(this.inicializarTabla({ elementos: this.tablaCedulas.cedulas }));
        },
        /**
         * Funcion encargada de construr la peticion para el servicio REST para la consulta de cedulas
         * formato = [JuzgadoId, Consecutivo, TipoDeCedulaId, TipoDeEstatusId, TipoDeEstatusId, FechaInicial, FechaFinal, EsPrueba]
         */
        construirPeticionBusquedaDeCedulas: async function() {
            const { juzgadoId, estatus, tipoNotificacion, numeroExpediente, fechaInicial, fechaFinal, grupos, tipoDeDocumento } = this.tablaCedulas.filtros;
            let peticion = {};
            peticion.JuzgadoId = (this.campoRequeridoEsValido(juzgadoId)) ? juzgadoId : null;
            peticion.Consecutivo = (this.campoRequeridoEsValido(numeroExpediente)) ? numeroExpediente : null;
            peticion.TipoDeCedulaId = (this.campoRequeridoEsValido(tipoNotificacion.tipoNotificacionId)) ? tipoNotificacion.tipoNotificacionId : null;
            peticion.TipoDeEstatusId = (this.campoRequeridoEsValido(estatus.tipoDeEstatusId)) ? estatus.tipoDeEstatusId : null;
            peticion.FechaInicial = (this.campoRequeridoEsValido(fechaInicial) && grupos.rangoDeFechas.activo) ? fechaInicial : null;
            peticion.FechaFinal = (this.campoRequeridoEsValido(fechaFinal) && grupos.rangoDeFechas.activo) ? fechaFinal : null;
            peticion.TipoDocumentoId = (this.campoRequeridoEsValido(tipoDeDocumento.tipoDeDocumentoId)) ? tipoDeDocumento.tipoDeDocumentoId : null;
            peticion.EsPrueba = false;
            return peticion;
        },
         /**
         * Funcion encargada de llamar a servicio REST para obtener las cedulas
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
        obtenerCedulasBD: async function({ peticion, conMensajeDeRespuesta = true }) { 
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaSistemaViejo.ObtenerCedulas;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Cedulas, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    moment.locale('es'); 
                    this.tablaCedulas.cedulas = (this.campoRequeridoEsValido(Cedulas)) 
                        ? Cedulas.map(cBD => {
                                let cObj = { ...cBD };
                                cObj.FechaDeCreacion = (this.campoRequeridoEsValido(cObj.FechaDeCreacion)) ? moment(cObj.FechaDeCreacion).format("DD MMMM YYYY") : '';
                                cObj.FechaRecibeJuzgado = (this.campoRequeridoEsValido(cObj.FechaRecibeJuzgado)) ? moment(cObj.FechaRecibeJuzgado).format("DD MMMM YYYY") : '';
                                cObj.FechaDeResultado = (this.campoRequeridoEsValido(cObj.FechaDeResultado)) ? moment(cObj.FechaDeResultado).format("DD MMMM YYYY") : '';
                                cObj.AccionVerDocumento = (this.campoRequeridoEsValido(cObj.rutaDocumento)) ? this.obtenerHTMLAcciones() : `<i title="No hay documento" class="far fa-folder-open text-danger"></i>`;
                                return cObj;
                            })
                        : [];
                    procesoSinError = true;
                    if(conMensajeDeRespuesta && this.campoRequeridoEsValido(Satisfactorio))
                        comun.mensajeDeAlerta(Satisfactorio);
                }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        manipularVisualizacionModal: function({ idModal, mostrar }) {
            const ACCION = (mostrar) ? 'show' : 'hide';
            $('#' + idModal).modal(ACCION);
        },
        evtCambioDeJuzgado: function(evento) {
            this.tablaCedulas.filtros.juzgadoId = parseInt(evento.target.value);
        },
        evtCambioTipoEstatus: function(evento) {
            this.tablaCedulas.filtros.estatus.tipoDeEstatusId = parseInt(evento.target.value);
        },
        evtCambioTipoNotificacion: function(evento) {
            this.tablaCedulas.filtros.tipoNotificacion.tipoNotificacionId = parseInt(evento.target.value);
        },
        evtCambioTipoDeDocumento: function(evento) {
            this.tablaCedulas.filtros.tipoDeDocumento.tipoDeDocumentoId = parseInt(evento.target.value);
        },
        /**
         * Funcion encargada de obtener el listado de estatus para la construccion del catalogo
         * @param {Boolean} visualizarCargaDeInformacion [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
        obtenerTiposDeDocumentosBD: async function({ visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.catalogos.CCatTipoDocumento;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = { EsPrueba: false };
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, TiposDeDocumentos } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    this.tablaCedulas.filtros.tipoDeDocumento.lista = (this.campoRequeridoEsValido(TiposDeDocumentos)) 
                        ? TiposDeDocumentos.map(tdocBD => ({ llave: tdocBD.TipoDeDocumentoId, valor: tdocBD.Descripcion }))
                        : [];
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
         /**
         * Funcion encargada de obtener el listado de estatus para la construccion del catalogo
         * @param {Boolean} visualizarCargaDeInformacion [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
        obtenerEstatusBD: async function({ visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.catalogos.CCatEstatusNotif;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = { EsPrueba: false };
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Estatus } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    this.tablaCedulas.filtros.estatus.lista = (this.campoRequeridoEsValido(Estatus)) 
                        ? Estatus.map(eBD => ({ llave: eBD.EstatusId, valor: eBD.NomDescripcion }))
                        : [];
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        /**
         * Funcion encargada de obtener el listado de tipos de notificacion para la construccion del catalogo
         * @param {Boolean} visualizarCargaDeInformacion [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
        obtenerTiposDeNotificacionBD: async function({ visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.catalogos.CCatTipoNotificacion;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = { EsPrueba: false };
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, TiposDeNotificaciones } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: this.tablaCedulas.cedulas }));
                } 
                else { 
                    this.tablaCedulas.filtros.tipoNotificacion.lista = (this.campoRequeridoEsValido(TiposDeNotificaciones)) 
                        ? TiposDeNotificaciones.map(tpNotBD => ({ llave: tpNotBD.TipoNotificacionId, valor: tpNotBD.Descripcion }))
                        : [];
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
         /**
         * Funcion encargada de inicializar los contenidos de la cedulas
         * @param {Array} elementos [lista de cedulas a mostrar]
         */
        inicializarTabla: async function({ elementos }) { 
            this.$nextTick(() => {
                $("#" + this.tablaCedulas.ID).bootstrapTable({  data: elementos });      
                $("#" + this.tablaCedulas.ID).bootstrapTable('load', elementos ); 
                $("#" + this.tablaCedulas.ID).bootstrapTable('toggleView');
            });
            $("#" + this.tablaCedulas.ID).bootstrapTable('toggleView');
        },
        obtenerHTMLAcciones: () => {
            return [
                '<div>',
                    '<button id="btn-cedula-SINOJ-visor" title="Ver documento" type="button" class="btn-ver-documento-SINOJ btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-eye"></i> &nbsp;&nbsp;Ver documento</button>',
                '</div>'
            ].join("");
        },
        verificarCargaAreaDeUsuarioEnStore: function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) { 
                this.cargoAreaDeUsuario = true;
                this.asignarValoresUsuarioEnFiltrosDeBusqueda(this.$store.state.Login_Usuario.Area);
            }
        },
        /**
         * Funcion encargada de llenar los catalogos segun el perfil de usuario y area
         * @param {Number} AreaId [id del area asignada del usuario]
         */
        asignarValoresUsuarioEnFiltrosDeBusqueda: function({ AreaId }) {
            const AREA_NOTIFICADORES_CIVILES = 36;
            if(AreaId != AREA_NOTIFICADORES_CIVILES) {
                this.tablaCedulas.filtros.juzgadoId = AreaId;
                this.tablaCedulas.filtros.contFJuzgado ++;
                this.tablaCedulas.filtros.filtroAreaInformativo = true;
            }
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
    },
    async mounted() {
        window.operateEvents = {
            "click #btn-cedula-SINOJ-visor": (e,val,row,index) => {   
                const CEDULA_OBJ = row;
                if(this.campoRequeridoEsValido(CEDULA_OBJ.rutaDocumento)) {
                    this.visor.cedulaSeleccionada = row;
                    this.manipularVisualizacionModal({ idModal: 'visor-documentos', mostrar: true });
                    this.visor.contRender ++;
                }
                else {
                    comun.mensajeDeAlerta('La cedula seleccionada no cuenta con un documento');
                }
            },
        };
        await Promise.resolve(this.inicializarTabla({ elementos: this.tablaCedulas.cedulas }));
    },
    async created() {
        comun.SeEstaCargandoInformacion(true);
        this.verificarCargaAreaDeUsuarioEnStore();
        await Promise.resolve(this.obtenerEstatusBD({ visualizarCargaDeInformacion: false }));
        await Promise.resolve(this.obtenerTiposDeNotificacionBD({ visualizarCargaDeInformacion: false }));
        await Promise.resolve(this.obtenerTiposDeDocumentosBD({ visualizarCargaDeInformacion: false }));
        comun.SeEstaCargandoInformacion(false);
    },
    watch: {
        '$store.state.Login_Usuario.Area': function() {
            this.$nextTick(() => {
                this.verificarCargaAreaDeUsuarioEnStore();
            });
        }
    }
}
</script>
<style scoped>
#visor-documentos .modal-lg {
    max-width: 70% !important;
}

#visor-documentos .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.texto-filtros {
    font-size: 1.1em;
}

.acciones {
    border-top: 1px solid rgb(27, 27, 27);
    background-color: #444444;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

#seccion-acciones .btn {
    padding: 0.3em 0.8em 0.3em 0.8em;
    font-size: 1.1em;
    background-color: black;
}

.titulo-contenedores-seccion h5 {
    font-size: 2.7vmin;
}

.titulo-contenedores-seccion {
    background-color: rgb(71, 71, 71);
    padding: 1.3em 2em 0.5em 2em;
    color: white;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.contenedor-color-negro {
    background-color: #323335;
    padding: 25px;
    border: 1px solid rgb(27, 27, 27);
}

#encabezados {
    margin-bottom: 1em;
}

#encabezados h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}
</style>
<style>
#filtros .input-group-text {
    border-top-left-radius: 0.6vmin;
    border-bottom-left-radius: 0.6vmin;
    border: none;
}

#filtros .form-control {
    border: none !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.contenedor-tabla-historico-CEDULAS-SINOJ td {
    background-color: rgb(238, 238, 238);
    vertical-align: middle;
}

.borderless td, .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #111111;
    font-size: 1em;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .btn-ver-documento-SINOJ:hover, .contenedor-tabla-historico-CEDULAS-SINOJ .btn-ver-documento-SINOJ:focus {
    background-color: #1c1d1d;
    border: 1px solid #e1e2e2;
    color: white;
}


.contenedor-tabla-historico-CEDULAS-SINOJ table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .card-view-title {
    margin-bottom: 0.3em !important;
    font-size: 1.3em !important;
    background-color: rgb(65, 65, 65) !important;
    color: white !important;
    padding: 0.2em 0.2em 0.2em 0.2em !important;
    display: flex !important;
    justify-content: start !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .card-view-value {
    font-size: 1.3em !important;
    padding: 0.2em 0.2em 0.2em 1.3em !important;
    font-weight: bold !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .pagination > li > a {
    background-color: white;
    color: #121213;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.contenedor-tabla-historico-CEDULAS-SINOJ > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/BitacoraCedulasAnteriores/CBitacoraCedulasAnteriores.vue